import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cabbage"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 21.9999C17.5228 21.9999 22 17.5829 22 12.0003C22 8.55601 19.1801 3.09159 15.5555 3.13098C13.3333 3.13098 12.8889 6.94985 12.8889 6.94985C13.2326 3.131 10.1543 1.58447 6.99788 3.35243C3.97983 5.04289 2 8.21712 2 12.0003C2 17.0349 5.64133 21.1013 10.4071 21.8724C10.9258 21.9563 11.4579 21.9999 12 21.9999Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14.4444 11.667C13.6823 11.5337 12.6791 11.6261 12 12.0003C10.5266 12.8121 9.75148 14.68 9.68214 16.6087C9.62457 18.2099 9.90025 19.9304 10.2591 21.3292M14.4444 11.667C14.8427 10.2578 16.4011 9.07414 17.9999 8.68186C20.3706 8.10021 21.9722 9.66106 22 12C22 8.55575 19.1801 3.09159 15.5555 3.13098C14.1641 3.13098 13.4697 4.62817 13.1449 5.74765M14.4444 11.667C14.6943 10.4728 14.7252 9.64706 14.4444 8.90918C14.2122 8.29894 13.7669 7.7488 13.0561 7.10001C13.0008 7.0495 12.9447 6.99983 12.8889 6.94985C13.2326 3.131 10.1543 1.58447 6.99788 3.35243C3.97983 5.04289 2 8.21712 2 12.0003C2 17.0349 5.64132 21.1013 10.4071 21.8724C10.9258 21.9563 11.4579 21.9999 12 21.9999C17.4356 21.9999 21.9466 17.5296 22 12.1C22 12.1 22.0002 12.0875 22 12.0875M6.88884 8.87566L9.99995 5.82654M17.875 8.47164L17 7.00027M10.9 21.3292L18.4444 13.0146M14.431 16.7L14.4444 14.8117M9.22186 16.1032L5.99994 12.5653M11.9665 11.75C11.7305 10.7978 10.2733 9.29225 8.44441 10.3193C7.70798 9.86118 7.04263 9.53195 6.44439 9.31122C4.44286 8.57275 3.19269 8.90733 2.54577 9.85002C2.53446 9.8665 2.52333 9.88317 2.51239 9.90002","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Cabbage = Vue.extend<IconProps>({
  name: 'CabbageIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cabbage',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cabbage;
